import React from "react";
import { Modal } from "react-bootstrap";

const PDFModal = ({ show, onHide, title, pdfUrl }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      backdrop="static"
      keyboard={false}
      fullscreen="md-down"
      dialogClassName="pdf-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body 
        style={{ 
          height: "80vh",
          maxHeight: "calc(100vh - 120px)",
          padding: 0,
          overflow: "auto",
          WebkitOverflowScrolling: "touch"
        }}
      >
        <iframe
          src={pdfUrl}
          title={title}
          width="100%"
          height="100%"
          style={{ 
            border: "none",
            display: "block",
            minHeight: "500px"
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PDFModal;
